import React, { useContext, useState } from "react";
import { Box, Button, Typography } from "@mui/material";

import { SecondaryWindow } from "../ui/windows";
import { DefinitionsContext } from "../../context/DefinitionsContext";

function ConfirmationDialog({
  title,
  text,
  isOpen,
  onClose,
  onConfirm,
  children,
  sx = {},
}) {
  const { translationList } = useContext(DefinitionsContext);

    const effectiveTitle = title || translationList.areYouSure;
  return (
    <SecondaryWindow
      isOpen={isOpen}
      onClose={onClose}
      title={effectiveTitle}
      sx={{
        ...sx,
        minWidth: "350px",
        minHeight: "80px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Typography variant="body">{text}</Typography>
        {children}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            marginTop: "30px",
          }}
        >
          <Button variant="outlined" onClick={onClose}>
            {translationList.cancel}
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={async () => {
              if (typeof onConfirm === "function") {
                const result = onConfirm();
                if (result instanceof Promise) {
                  await result;
                }
              }
              onClose();
            }}
          >
            {translationList.confirm}
          </Button>
        </Box>
      </Box>
    </SecondaryWindow>
  );
}

export { ConfirmationDialog };
export default ConfirmationDialog;
